var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.routeName !== "agreement" ? _c("div", {
    class: ["header-warp", {
      white: _vm.changeBg,
      bg: _vm.routeName === "homepage" && !_vm.changeBg
    }],
    style: {
      background: _vm.changeBg ? "#fff" : ""
    }
  }, [!_vm.noHeaderRouter.includes(_vm.routeName) ? _c("div", {
    ref: "header",
    staticClass: "app-header",
    class: {
      dark: _vm.routeName === "404",
      beinmiddle: _vm.changeBg
    }
  }, [_c("div", {
    staticClass: "left-cont"
  }, [_c("router-link", {
    attrs: {
      to: "/"
    }
  }, [_c("img", {
    staticClass: "logo",
    attrs: {
      src: require("@/assets/images/logo-block.png"),
      alt: "logo"
    }
  })]), _c("section", {
    staticClass: "app-header__menu"
  }, [_c("nav-menu", {
    attrs: {
      scrollTop: _vm.scrollTop,
      changeBg: _vm.changeBg
    }
  })], 1)], 1), _c("div", {
    staticClass: "right-wrap"
  }, [!_vm.carShow && _vm.productList.length !== 0 ? _c("div", {
    staticClass: "app-header_search"
  }, [_c("div", {
    ref: "searchItem",
    class: ["item1", _vm.showContent ? "item-big" : ""]
  }, [_c("div", [_c("a-input", {
    attrs: {
      placeholder: "请输入您想查询的关键词"
    },
    on: {
      keyup: _vm.keydown,
      focus: _vm.handleFocus,
      change: _vm.change
    },
    scopedSlots: _vm._u([{
      key: "suffix",
      fn: function () {
        return [_c("a-icon", {
          attrs: {
            type: "search"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return _vm.onSearch(_vm.text);
            }
          }
        }), _vm._v(" "), _c("span", {
          staticStyle: {
            margin: "0 5px"
          }
        }, [_vm._v("|")]), _c("a-icon", {
          attrs: {
            type: "close"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return _vm.clear.apply(null, arguments);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 3784310183),
    model: {
      value: _vm.text,
      callback: function ($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  })], 1), _c("div", {
    class: ["content", _vm.showContent ? "content-toogle" : "", _vm.historyList.length === 0 && _vm.recommedList.length === 0 ? "noshadow" : ""]
  }, [_vm.showList ? _c("div", {
    staticClass: "list-before"
  }, [_vm.historyList.length > 0 ? _c("div", {
    staticClass: "content-history"
  }, [_c("p", [_c("span", [_vm._v("搜索历史")]), _c("a-icon", {
    staticClass: "delete-icon",
    attrs: {
      type: "delete"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.deleteHistory.apply(null, arguments);
      }
    }
  })], 1), _c("ul", _vm._l(_vm.historyList, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "single-word",
      attrs: {
        title: item
      },
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.toSearch("history", item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0)]) : _vm._e(), _vm.recommedList.length > 0 ? _c("div", {
    staticClass: "content-history"
  }, [_vm._m(0), _c("ul", _vm._l(_vm.recommedList, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "single-word",
      attrs: {
        title: item.label_name
      },
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.toSearch("recommend", item.label_name);
        }
      }
    }, [_vm._v(_vm._s(item.label_name))]);
  }), 0)]) : _vm._e()]) : _c("div", [_c("a-spin", {
    staticStyle: {
      margin: "80px 150px"
    },
    attrs: {
      spinning: _vm.pageLoading
    }
  }), _vm.searchData.component.length === 0 && _vm.searchData.interface.length === 0 && _vm.searchData.category.length === 0 && !_vm.showList ? _c("div", {
    staticClass: "nodata"
  }, [_vm._v("暂无数据")]) : _vm._e(), !_vm.pageLoading && (_vm.searchData.component.length !== 0 || _vm.searchData.interface.length !== 0 || _vm.searchData.category.length !== 0) ? _c("div", {
    staticClass: "list-after"
  }, [_vm.searchData.component.length > 0 ? _c("div", {
    staticClass: "content-after"
  }, [_c("p", [_vm._v("组件")]), _c("ul", _vm._l(_vm.searchData.component, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "single-word",
      attrs: {
        title: item.associated_name
      },
      on: {
        click: function ($event) {
          return _vm.toOpenai("component", item);
        }
      }
    }, [_vm._v(_vm._s(item.associated_name))]);
  }), 0)]) : _vm._e(), _vm.productType && _vm.searchData.interface.length > 0 ? _c("div", {
    staticClass: "content-after"
  }, [_c("p", [_vm._v("接口")]), _c("ul", _vm._l(_vm.searchData.interface, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "single-word",
      attrs: {
        title: item.associated_name
      },
      on: {
        click: function ($event) {
          return _vm.toOpenai("interface", item);
        }
      }
    }, [_vm._v(_vm._s(item.associated_name))]);
  }), 0)]) : _vm._e(), _vm.productType && _vm.searchData.category.length > 0 ? _c("div", {
    staticClass: "content-after"
  }, [_c("p", [_vm._v("接口分类")]), _c("ul", _vm._l(_vm.searchData.category, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "single-word",
      attrs: {
        title: item.group_name
      },
      on: {
        click: function ($event) {
          return _vm.toOpenai("category", item);
        }
      }
    }, [_vm._v(_vm._s(item.group_name))]);
  }), 0)]) : _vm._e()]) : _vm._e()], 1)])])]) : _vm._e(), _c("div", {
    staticClass: "en",
    on: {
      click: _vm.jumpEnSite
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/icon-chinese.png"),
      alt: "chinese"
    }
  }), _c("span", [_vm._v("英文")])]), _vm.routeName !== "404" ? _c("div", {
    staticClass: "login-btn"
  }, [!_vm.haslogin ? _c("router-link", {
    attrs: {
      to: "/login"
    }
  }, [_c("span", {
    staticClass: "login",
    attrs: {
      role: "button"
    }
  }, [_vm._v("登录")])]) : _c("a-dropdown", {
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c("a-menu", [_c("a-menu-item", [_c("a", {
          on: {
            click: _vm.toPersonal
          }
        }, [_vm._v("个人中心")])]), _c("a-menu-item", [_c("a", {
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return _vm.toPersonal("product");
            }
          }
        }, [_vm._v("试用中产品：" + _vm._s(_vm.useProduct.length))])]), _c("a-menu-item", [_c("a", {
          on: {
            click: _vm.handleLogout
          }
        }, [_vm._v("退出登录")])])], 1)];
      },
      proxy: true
    }], null, false, 732411906)
  }, [_c("a", {
    staticClass: "ant-dropdown-link",
    on: {
      click: function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c("span", {
    class: _vm.changeBg ? "white" : ""
  }, [_vm._v("您好，" + _vm._s(_vm.customername) + " "), _c("a-icon", {
    attrs: {
      type: "down"
    }
  })], 1)])])], 1) : _vm._e(), !_vm.haslogin ? _c("div", {
    staticClass: "register",
    on: {
      click: _vm.goRegister
    }
  }, [_vm._v(" 注册 ")]) : _vm._e()])]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("p", [_c("span", [_vm._v("推荐热门")]), _vm._v(" "), _c("span", {
    staticClass: "hot"
  }, [_vm._v("hot")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };